import { render, staticRenderFns } from "./subscribeBlock.vue?vue&type=template&id=94418c2a&scoped=true&"
import script from "./subscribeBlock.vue?vue&type=script&lang=js&"
export * from "./subscribeBlock.vue?vue&type=script&lang=js&"
import style0 from "./subscribeBlock.vue?vue&type=style&index=0&id=94418c2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94418c2a",
  null
  
)

export default component.exports